export enum SummaryTabNames {
  summary = "Summary",
  members = "Members",
  treasury = "Treasury",
  vault = "Vault",
  proposals = "Proposals",
  applications = "Applications",
  invitations = "Invitations",
  staking = "Staking",
}

export enum SummaryTabIdentifiers {
  summary = "Summary",
  members = "Members",
  treasury = "Treasury",
  vault = "Vault",
  proposals = "Proposals",
  applications = "Applications",
  invitations = "Invitations",
  staking = "Staking",
}

export enum InvitationStatus {
  Uninvited,
  Invited,
  Accepted,
  Rejected,
  Canceled,
}

export enum ClubType {
  TokenProportional = 0,
  TokenEqual = 1,
  RoleBased = 2,
  NftBased = 3,
  ProjectFundraise = 4,
}

export enum TreasuryFundraiseStatus {
  ActiveFundraise,
  NoActiveFundraiseNoPreviousFundraises,
  NoActiveFundraiseWithPreviousFundraises,
}

export enum ClubSortType {
  NewestFirst,
  OldestFirst,
  HighestFundsRaisedFirst,
  HighestNumberOfMembersFirst,
  HighestNumberOfNFTsFirst,
}

export enum ApplicationStatus {
  Open,
  Closed,
}

export enum FilterType {
  ClubType,
  ApplicationStatus,
  ActiveFundraising,
}

export enum FilterKeys {
  ApplicationStatus = "applicationStatus",
  ClubType = "clubType",
  ActiveFundraising = "activeFundraise",
  Tags = "tags",
  SortBy = "sortBy",
  SearchParam = "searchParam",
}

export enum SequenceType {
  Sequential,
  Parallel,
  StopOnFailure,
}

export enum SharesTradeType {
  Buy,
  Sell,
}

export enum SupportType {
  Deposit = 0,
  Withdraw = 1,
}

export enum ClubCreationAccounts {
  createTreasury = "createTreasury",
  createVault = "createVault",
}
